<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon" [searchEnabled]="true" [openSearchDialogCallback]="showFilterDialog" [isFilterApplied]="isFilterApplied">
</app-page-title>
<div *ngIf="!usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList')">
    You have no rights to access this page
</div>
<div *ngIf="!!fullAudiences && usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList')">
    <mat-tab-group (selectedTabChange)="tabChange($event)">
        <mat-tab label="Active"></mat-tab>
        <mat-tab label="Archived" *ngIf="showArchivedTab"></mat-tab>
    </mat-tab-group>
    <eris-table [dataSource]="audiencesDataSource" #parent>
        <ng-container *ngFor="let audience of parent.data; index as i">   
            <tr>
                <th scope="row" class="align-middle" style="width: 5%;">{{ audience.id }}</th>
                <td class="align-middle" style="width: 28%; word-break: break-all;">{{ audience.name }}</td>
                <td class="align-middle" style="width: 7%;">{{ audience.created | date }}</td>
                <td class="align-middle" style="width: 7%;">{{ audience.updated | date }}</td>
                <td class="align-middle" style="width: 5%;">{{ audience.profilesCount | number:'':'es' }}</td>
                <td class="align-middle" style="width: 22%;">
                    <ng-container *ngFor="let item of audience.identifiersCounts | keyvalue">
                        <div *ngIf="item.value > 0 && item.key != '6'">{{ audiencesService.getIdGraphTypeDescription(+item.key) }}: {{ item.value |
                            number:'':'es'}}</div>
                    </ng-container>
                    <br/>
                    <div *ngIf="!!audience.homesCount">Homes count: {{ audience.homesCount | number:'':'es' }}</div>
                </td>                
                <td class="align-middle" style="width: 4%;" *ngIf="usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesList', 'Manage')">
                    <div>
                        <div class="font-icon-wrapper-button" (click)="showAudienceDetails(audience)" style="cursor:pointer;display:inline-flex;width:44px;height:44px; ">
                            <i class="pe-7s-info"></i>
                            <i class="pe-7s-ticket" style="font-size:1.2em;position:relative;left:-10px;top:20px" *ngIf="!!audience.tags && audience.tags.length > 0"></i>
                        </div>
                    </div>
                </td>
                <td class="align-middle" style="width: 8%;">
                    <div>
                        <div class="font-icon-wrapper">
                            <i [class]="getStatusStyle(audience)"></i>
                        </div>
                        <div class="d-flex justify-content-center" style="text-align:center">
                            {{ getStatusLabel(audience) }}
                        </div>
                    </div>
                </td>             
                <td class="align-middle" style="width: 4%;" *ngIf="usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesList', 'Manage')">
                    <div *ngIf="audience?.status != 10">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" (menuOpened)="stopRefreshPolling()">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" (closed)="onMenuClosed($event)">
                            <button mat-menu-item [disabled]="audience?.status != 2 && audience?.status != 3" (click)="refreshAudience(audience)">
                                <mat-icon class="pe-7s-refresh-2"></mat-icon>
                                <span>Refresh</span>
                            </button>
                            <mat-divider></mat-divider>
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="calculateLookAlikeParameters(audience)" *ngIf="!audience.lookAlikeParametersCalculated">
                                <mat-icon class="pe-7s-power"></mat-icon>
                                <span>Calculate look-alike parameters</span>
                            </button>
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="showLookAlikes(audience)" *ngIf="audience.lookAlikeParametersCalculated">
                                <mat-icon class="pe-7s-users"></mat-icon>
                                <span>Show look alikes</span>
                            </button>
                            <mat-divider></mat-divider>
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="navigateAudienceTransfers(audience)">
                                <mat-icon class="pe-7s-albums"></mat-icon>
                                <span>Audience transfers</span>
                            </button>                            
                            <mat-divider></mat-divider>   
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="updateAudience(audience)">
                                <mat-icon class="pe-7s-pen"></mat-icon>
                                <span>Edit audience</span>
                            </button>                            
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="moveAudience(audience)">
                                <mat-icon class="pe-7s-repeat"></mat-icon>
                                <span>Move audience</span>
                            </button>       
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="deleteAudience(audience)">
                                <mat-icon class="pe-7s-trash"></mat-icon>
                                <span>Archive / Delete audience</span>
                            </button>
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="addComment(audience)">
                                <mat-icon class="pe-7s-note"></mat-icon>
                                <span>Add comment</span>
                            </button>                            
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="downloadRational(audience)">
                                <mat-icon class="pe-7s-magic-wand"></mat-icon>
                                <span>Generate rational</span>
                            </button>                            
                            <mat-divider></mat-divider>  
                            <button mat-menu-item [disabled]="audience?.status != 2" (click)="manageAudienceTags(audience)">
                                <mat-icon class="pe-7s-ticket"></mat-icon>
                                <span>Tags</span>
                            </button>                                                                                                   
                        </mat-menu>
                    </div>
                    <div *ngIf="audience?.status == 10">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="refreshAudience(audience)">
                                <mat-icon class="pe-7s-refresh-2"></mat-icon>
                                <span>Refresh</span>
                            </button>
                        </mat-menu>
                    </div>                    
                </td>               
            </tr>
        </ng-container>
    </eris-table>
</div>